import ProductSearch from './components/ProductSearch.vue';
import ProductDetail from './components/ProductDetail.vue';
import ConvertionsDetail from './components/ConvertionsDetail.vue';
import ApplicationsDetail from './components/ApplicationsDetail.vue';
import ExactSearch from './components/ExactSearch';
import ExactDetail from './components/ExactDetail';
import ExactProductDetail from './components/ExactProductDetail';

const routes = [
	{ path: '/', component: ProductSearch },
	{ path: '/codigovclean', component: ProductSearch },
	{ path: '/brand/:brand/model/:model/year/:year', component: ProductDetail, props: true },
	{ path: '/convertions/:code', component: ConvertionsDetail, props: true },
	{ path: '/applications/:code', component: ApplicationsDetail, props: true },
	{ path: '/codigovclean/applications/:code', component: ApplicationsDetail, props: true },
	{ path: '/exact', component: ExactSearch },
	{ path: '/exact/:code', component: ExactDetail, props: true },
	{ path: '/exact/brand/:brand/model/:model/year/:year', component: ExactProductDetail, props: true },

];

export default routes;
